import React from 'react';
import { I18n } from '@aws-amplify/core';
import { RiskLabel, RiskContainer } from './styles';

interface RiskScore {
	result?: number;
	score?: number;
}

export function RiskEvaluation({ result = 0, score = 0 }: Readonly<RiskScore>) {
	return (
		<>
			<RiskLabel>{I18n.get('Risk')}</RiskLabel>
			<RiskContainer $result={result}>
				<span>Score: {score}</span>
			</RiskContainer>
		</>
	);
}
